// src/utils/apiClient.js

export async function listVeilles() {
  const res = await fetch('/api/listVeilles');
  if (!res.ok) throw new Error('Impossible de charger les veilles');
  return res.json();
}

export async function createVeille({ themes, destinataire }) {
  const res = await fetch('/api/createVeille', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ themes, destinataire })
  });
  if (!res.ok) throw new Error('Création de veille échouée');
  return res.json();
}

export async function updateVeille({ created_at, destinataire_original, themes, destinataire }) {
  const res = await fetch('/api/updateVeille', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ created_at, destinataire_original, themes, destinataire })
  });
  if (!res.ok) throw new Error('Mise à jour de veille échouée');
  return res.json();
}

export async function setVeilleActive({ created_at, destinataire, actif }) {
  const res = await fetch('/api/setVeilleActive', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ created_at, destinataire, actif })
  });
  if (!res.ok) throw new Error('Mise à jour du statut échouée');
  return res.json();
}

export async function listSentEmails() {
  const res = await fetch('/api/listSentEmails');
  if (!res.ok) throw new Error("Impossible de charger les emails envoyés");
  return res.json();
}
